import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField,
} from '@mui/material';
import * as C from '../../../theme/colors.constants';

/**
 * Dialog "Exibir Detalhes" (AW2-1133 Etapa 5) — port de `DialogAcompanhemento.jsx`
 * real (`Acordos.jsx`, já MUI v5 em produção). Somente leitura, sem
 * fetch/mutação — `texto` já vem carregado na linha da grid
 * (`acordosController.mapearAcordos`), por isso não usa o guard
 * `useSessaoDialogMutacao` (reservado para dialogs com chamada assíncrona
 * real).
 *
 * `texto` renderizado via `value` do `TextField` (nunca
 * `dangerouslySetInnerHTML`) — evita XSS mesmo que o backend algum dia
 * devolva HTML no campo.
 */
export default function DialogHistoricoAcordo({ open, texto, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Histórico</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          multiline
          rows={4}
          disabled
          value={texto ?? ''}
          sx={{ '& .MuiInputBase-input.Mui-disabled': { WebkitTextFillColor: C.blackTwo } }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>OK</Button>
      </DialogActions>
    </Dialog>
  );
}

DialogHistoricoAcordo.propTypes = {
  open: PropTypes.bool,
  texto: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

DialogHistoricoAcordo.defaultProps = {
  open: false,
  texto: '',
};
